<template>
  <div class="customer-example-container">
    <div class="content-container">
      <div class="jindie-logo">
        <img src="../../../assets/images/kindee_logo.png">
        <hr>
        <p>金蝶</p>
      </div>
      <div class="nfdw-logo">
        <img src="../../../assets/images/nanfang_logo.png">
        <hr>
        <p>中国南方电网</p>
      </div>
      <div class="huawei-logo">
        <img src="../../../assets/images/huawei_logo.png">
        <hr>
        <p>华为</p>
      </div>
      <div class="zhaoshang-logo">
        <img src="../../../assets/images/cmb-logo.png">
        <hr>
        <p>招商银行</p>
      </div>
      <div class="jxjs-logo">
        <img src="../../../assets/images/jiuxin_logo.png">
        <hr>
        <p>九芯净水</p>
      </div>
      <div class="zx-logo">
        <img src="../../../assets/images/zhongxin_logo.png">
        <hr>
        <p>中信银行</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerExample'
}
</script>

<style scoped lang="stylus">
  .customer-example-container
    .content-container
      width: 1170px
      display: flex;
      flex-wrap: wrap-reverse;
      justify-content: space-around;
      text-align: center
      margin: 0 auto

      div
        width: 330px
        height: 220px
        text-align: center
        border-radius: 10px
        box-shadow: 0px 7px 24px #dbdbdb
        padding-top: 40px
        margin-top: 50px

        img
          width: 91%
        hr
          border: 2px solid #e5e5e5
          width: 190px
        p
          display: inline-block
          border: 4px solid #e5e5e5
          padding: 6px 15px
      .jxjs-logo
        padding-top: 40px
</style>



// WEBPACK FOOTER //
// src/pages/example/components/CustomerExample.vue